import React from "react";
import { connect } from "react-redux";
import { Actions as INTEGRATION_ACTIONS } from "../../store/actions/integrationActions";

import { LinkIcon } from "@/icons/outline";

const linkEmployeeIntegrations = ["Tanda"];

const BulkLink = ({ userPermissions, hasIntegration, openModal }) => {
	if (!hasIntegration || userPermissions === "Read") return null;

	return (
		<button
			type="button"
			className="btn btn-default pull-right"
			onClick={() => {
				openModal()
			}}
		>
			<LinkIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
			<div style={{ float: "left" }}>Link Employees</div>
		</button>
	);
};

const mapStateToProps = (state) => {
	const hasIntegration =
		Object.values(state.integration || {})?.reduce((prev, curr) => {
			Object.values(curr || {})?.reduce((prev, curr) => {
				if (linkEmployeeIntegrations.includes(curr.name)) prev.push(curr.name);
				else return prev;
			}, prev);
			return prev;
		}, [])?.length > 0;
	return {
		hasIntegration,
		userPermissions: state?.permissions?.my?.permissions?.people,
	};
};

const mapDispatchToProps = (dispatch) => ({
	openModal: () => dispatch(INTEGRATION_ACTIONS.toggleBulkLinkModal(true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BulkLink);
